__turbopack_context__.v({
  "certificationsCarousel": "Certifications-module-scss-module__vZic5q__certificationsCarousel",
  "desktopContainer": "Certifications-module-scss-module__vZic5q__desktopContainer",
  "detailedContainer": "Certifications-module-scss-module__vZic5q__detailedContainer",
  "regularHeightDesktop": "Certifications-module-scss-module__vZic5q__regularHeightDesktop",
  "shortDesktop": "Certifications-module-scss-module__vZic5q__shortDesktop",
});
